module.exports = "<!DOCTYPE html>\n<html>\n<head>\n  <meta charset=\"UTF-8\">\n  <title>Certificado</title>\n</head>\n<body style=\"margin:0; padding:0; background-color:#ffffff; font-family: 'Maven Pro', sans-serif;\">\n  <div>\n    <div ng-bind-html=\"trustedHtml($ctrl.certificado)\"></div>\n  </div>\n</body>\n</html>"


//////////////////
// WEBPACK FOOTER
// ./app/components/asistencia/certificado.html
// module id = 380
// module chunks = 0